<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="12"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100vh">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" tablet="12">
                <div class="font-400 font-size-24px  color-base-700 mt-15 mb-15">
                    {{"Assistance" | translate }}
                 </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-20 p-16" *ngFor="let A of this.Assitantlist">
                    <grid-row class="col-space-min align-item-center">
                        <grid-col col="auto">
                            <!-- <ng-icon iconClass="data:image/svg;base64+{{A.icon}}" width="40" height="40"></ng-icon> -->
                            <img [src]="A.icon" alt="" width="25" height="25">
                            <!-- <img [src]="data:image/svg;base64+ A.icon" alt="" width="16" height="16"> -->
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
            <!-- {{"RoadsideAssistance" | translate}} -->{{A.title}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <div class="mt-10" *ngFor="let P of A.assistancePoints">
                        <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                            <!-- {{"Towingorremovalof" | translate}} -->{{P.description}}
                        </div>
                       
                    </div>
                    <div class="bg-color-base-3400 p-16 mt-15" *ngFor="let C of A.assistanceContactDetails">
                        <grid-row class="col-space-min align-item-center justify-content-between"  >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"CALL" | translate }} {{C.contactNumber1}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:{{C.contactNumber1}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24" *ngIf="C.contactNumber1 != ''"  ></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>

                        <grid-row class="col-space-min align-item-center justify-content-between mt-10" *ngIf="C.contactNumber2 != ''" >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"CALL" | translate }} {{C.contactNumber2}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:{{C.contactNumber2}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>

                        <grid-row class="col-space-min align-item-center justify-content-between mt-10" *ngIf="C.contactNumber3 != ''" >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"CALL" | translate }} {{C.contactNumber3}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:{{C.contactNumber3}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>

                        

                        <grid-row class="col-space-min align-item-center justify-content-between mt-10" *ngIf="C.whatsAppNumber1 != ''" >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"CALL" | translate }} {{C.whatsAppNumber1}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:{{C.whatsAppNumber1}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>

                        <grid-row class="col-space-min align-item-center justify-content-between mt-10" *ngIf="C.whatsAppNumber2 != ''" >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"CALL" | translate }} {{C.contactNumber2}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:{{C.contactNumber2}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>

                        <grid-row class="col-space-min align-item-center justify-content-between mt-10" *ngIf="C.email != ''" >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"Mail" | translate }} {{"to" | translate }} {{C.email}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="mailto:{{C.email}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>

                        <grid-row class="col-space-min align-item-center justify-content-between mt-10" *ngIf="C.email2 != ''" >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                     {{"Mail" | translate }} {{"to" | translate }} {{C.email2}}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:{{C.email}}">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>
                    </div>

                    <div class="bg-color-base-3400 p-16 mt-15" *ngIf="A.assistanceContactDetails.length == 0">
                        <grid-row class="col-space-min align-item-center justify-content-between"  >
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200" >   
                                    {{"NoContactdetailsfound" | translate }}
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy disabled mr-10" width="24" height="24"></ng-icon>
                                <ng-icon iconClass="icon-phone-call disabled" width="24" height="24"></ng-icon>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>





                <!-- <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-20 p-16">
                    <grid-row class="col-space-min align-item-center">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-crown bg-nuetral-primary br-12" width="40" height="40"></ng-icon>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px color-base-3300">
                                {{"VIPCover" | translate}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <div class="mt-10">
                        <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                            {{"Pickupanddelivery" | translate}}
                        </div>
                        <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                            {{"Trafficinspectionandregistration" | translate}}
                        </div>
                        <div class="font-400 font-size-13px color-base-1400 border-bottom border-color-ddd pt-10 pb-10">
                            {{"Airportdropoff" | translate}}
                        </div>
                        <div class="font-400 font-size-13px color-base-1400 pt-10">
                            {{"Maximumof3emergency" | translate}}
                        </div>
                        <div class="font-400 font-size-13px color-base-1400">
                            <ul>
                                <li>
                                    {{"Electricityemergencyassistance" | translate}}
                                </li>  
                                <li>
                                    {{"Wateremergencyassistance" | translate}}
                                </li>
                                <li>
                                    {{"Assistanceincaseoflost" | translate}}
                                </li>
                                <li>
                                     {{"Helpincaseofbrokenwindows" | translate}}
                                </li>
                            </ul>
                        </div>
                       
                    </div>
                    <div class="bg-color-base-3400 p-16 mt-15">
                        <grid-row class="col-space-min align-item-center justify-content-between">
                            <grid-col col="auto">
                                <strong class="font-600 font-size-14px color-base-2200">   
                                    {{"CALL" | translate}} 17899390
                                </strong>
                            </grid-col>
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-copy mr-10" width="24" height="24"></ng-icon>
                                <a href="tel:17899390">
                                    <ng-icon iconClass="icon-phone-call" width="24" height="24"></ng-icon>
                                </a>
                            </grid-col>
                        </grid-row>
                    </div>
                </div> -->
            </grid-col>
        </grid-row>
    </div>
</div>